import React, { useCallback, useEffect, useState } from 'react';
import moment from 'moment';
import {
  Drawer, makeStyles, withStyles,
  Select, MenuItem,
} from '@material-ui/core';
import { useAuthState } from '@/plugins/Auth';
import TextField from '@/components/TextField';
import ProgressBackdrop from '@/components/ProgressBackdrop';
import config from '@/configs/config';
import { requestEnterpriseCardPayVerifying } from '../api/enterpriseCardPayVerifying';

const useStyles = makeStyles((theme) => ({
  body: {
    alignItems: 'stretch',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    flexShrink: 1,
    overflow: 'hidden',
    padding: theme.spacing(1.5, 0),
  },
  title: {
    fontSize: 18,
  },
  footer: {
    flexShrink: 0,
  },
  text: {
    padding: theme.spacing(0.5),
    marginTop: theme.spacing(0.5),
  },
  goBack: {
    cursor: 'pointer',
    backgroundColor: 'rgb(45,152,37)',
    border: 0,
    borderRadius: 8,
    color: 'white',
    fontSize: 16,
    fontWeight: 'bold',
    padding: theme.spacing(0.5),
    width: '100%',
    '&:disabled': {
      backgroundColor: '#d8d8d8',
    },
  },
  error: {
    color: 'red',
  },
}));

const StyledDrawer = withStyles((theme) => ({
  paper: {
    alignItems: 'stretch',
    display: 'flex',
    flexDirection: 'column',
    fontSize: 16,
    padding: theme.spacing(3, 0),
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    maxHeight: '90%',
    overflow: 'hidden',

    [theme.breakpoints.up('sm')]: {
      margin: '0 auto',
      width: 425,
    },

    '& > *': {
      paddingLeft: theme.spacing(3.5),
      paddingRight: theme.spacing(3.5),
    },
  },
}))(Drawer);

export default ({
  isOpen,
  onClose,
  reload,
  isEnterpriseCardPayVerifyModalClear = false,
  verifyingEnterpriseCardExpireTime = null,
}) => {
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const { token } = useAuthState();
  const [inputText, setInputText] = useState(null);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  const onOKClicked = useCallback(async () => {
    setIsLoading(true);
    setErrorMessage(null);
    try {
      const result = await requestEnterpriseCardPayVerifying(token, { data: inputText });
      if (result.status !== 'success') {
        throw new Error();
      } else {
        reload();
        if (inputText) setShowSuccessMessage(true);
        else onClose();
      }
    } catch (error) {
      console.error(error);
      setErrorMessage('發生錯誤，請稍候再試');
    }
    setIsLoading(false);
  }, [inputText, token]); //eslint-disable-line
  useEffect(() => {
    if (isOpen) {
      setInputText(null);
      setErrorMessage(null);
      setIsLoading(false);
      setShowSuccessMessage(false);
    }
  }, [isOpen]);
  return (
    <StyledDrawer
      anchor="bottom"
      onClose={onClose}
      open={isOpen}
    >
      {
        (showSuccessMessage) ? ( //eslint-disable-line
          <div className={classes.body}>
            {
              verifyingEnterpriseCardExpireTime && (
                <>
                  <div className={classes.title}>即將完成綁定</div>
                  <div className={classes.text}>
                    請在
                    <span style={{ color: 'rgb(45,152,37)', margin: '0px 5px' }}>{moment(verifyingEnterpriseCardExpireTime).format('YYYY-MM-DD HH:mm')}</span>
                    前至
                    {config.BrandNameTW}
                    機台前感應員工卡開門一次完成綁定。
                  </div>
                </>
              )
            }
          </div>
        )
          : (isEnterpriseCardPayVerifyModalClear ? (
            <div className={classes.body}>
              確定要解除綁定嗎?
            </div>
          ) : (
            <div className={classes.body}>
              <div className={classes.text}>選擇企業員工卡</div>
              <Select
                value="default"
                disabled={isLoading}
                input={<TextField />}
              >
                <MenuItem key="default" value="default">
                  聯詠員工卡
                </MenuItem>
              </Select>
              <div className={classes.text}>輸入員工編號</div>
              <TextField
                disabled={isLoading}
                value={inputText}
                onChange={(e) => { setInputText((e.target.value || '').trim().substring(0, 10)); setErrorMessage(null); }}
                innerRef={(ref) => ref && ref.children[0].focus()}
              />
            </div>
          ))
      }
      {
        errorMessage && <div className={classes.error}>{errorMessage }</div>
      }
      <div className={classes.footer}>
        {
          showSuccessMessage ? (
            <button
              disabled={isLoading}
              className={classes.goBack}
              onClick={onClose}
              type="button"
            >
              我知道了
            </button>
          ) : (
            <button
              disabled={isLoading}
              className={classes.goBack}
              onClick={onOKClicked}
              type="button"
            >
              確定
            </button>
          )
        }

      </div>
      {isLoading && <ProgressBackdrop isShow /> }
    </StyledDrawer>
  );
};
